import React from "react";
import { useAppLanguage } from "../../utils/appLanguage";

/** Per-language ring tint; same values as --astria-lang-tint in theme/astriaTokens.css, plus the packs it lacks. */
const LANG_TINT: Record<string, string> = {
  en: "#a78bff", th: "#c27bff", es: "#ff9f8a", pt: "#9ad7ff", ja: "#7a7fff", ko: "#bba0ff",
  id: "#ffb86c", ms: "#8ce0c3", vi: "#ff8fbf", fil: "#8fb3ff", hi: "#ffcc66", ar: "#ffd27f",
  de: "#7fb2ff", fr: "#f08fc0", zh: "#ff7a7a", mr: "#ff9f5a", ta: "#5fd0b5",
};

/**
 * Astria ring mark, tinted by the app language (read from i18n, so it never depends on a
 * data attribute being set). The hole is masked out, so it sits on any background.
 */
const AstriaRingLogo: React.FC<{ className?: string; alt?: string }> = ({ className = "w-11 h-11", alt = "Astria logo" }) => {
  const tint = LANG_TINT[useAppLanguage()] || LANG_TINT.en;
  return (
    <span
      role="img"
      aria-label={alt}
      className={`inline-block shrink-0 rounded-full ${className}`}
      style={{
        background: `conic-gradient(from 200deg, #f3c9a4, ${tint}, color-mix(in srgb, ${tint} 72%, #5b3fa8), #f3c9a4)`,
        WebkitMask: "radial-gradient(circle, transparent 36%, #000 38%)",
        mask: "radial-gradient(circle, transparent 36%, #000 38%)",
        transition: "background .3s ease",
      }}
    />
  );
};

export default AstriaRingLogo;
